import React from 'react'
import { Field, Formik, Form } from 'formik'
import { generalSettingsSchema } from './schema/general_settings.schema';
import { Input, Select } from '../../../../ui/forms/formik';
import { Col, Row, Button } from 'react-bootstrap';
import SelectFilter from '../../../../ui/select/SelectFilter';
import SelectSearch from '../../../../ui/select/SelectSearch';

const GeneralSettingsForm = ({
    genderOptions,
    countriesOptions,
    teamsOptions
}) => {

    return (
        <Formik
            initialValues={{}}
            validationSchema={generalSettingsSchema}
            onSubmit={(values, actions) => {
                alert(JSON.stringify(values, null, 2));
            }}
            validateOnMount
        >{(props) => (
                <Form className="formik">
                    <Row>
                        <Col lg={4}>
                            <Field
                                name="name"
                                label="Name"
                                placeholder="Name"
                                component={Input}
                                className="input input-flat input-xl"
                            />
                        </Col>
                        <Col lg={4}>
                            <Field
                                name="dateOfBirth"
                                label="Date of Birth"
                                placeholder="Date of Birth"
                                component={Input}
                                className="input input-flat input-xl"
                            />
                        </Col>
                        <Col lg={4}>
                            <Field
                                name="gender"
                                label="Gender"
                                placeholder="Gender"
                                component={Select}
                                className="select select-flat select-xl"
                                options={genderOptions}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <Field
                                name="email"
                                type="email"
                                label="Email"
                                placeholder="Email"
                                component={Input}
                                className="input input-flat input-xl"
                            />
                        </Col>
                        <Col lg={6}>
                            <Field
                                name="phone"
                                type="number"
                                label="Phone"
                                placeholder="Phone"
                                component={Input}
                                className="input input-flat input-xl"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <Field
                                name="birthCountry"
                                label="Birth Country"
                                placeholder="Birth Country"
                                component={Select}
                                className="select select-flat select-xl"
                                options={countriesOptions}
                            />
                        </Col>
                        <Col lg={6}>
                            <Field
                                name="passportCountry"
                                label="Passport Country"
                                placeholder="Passport Country"
                                component={Select}
                                className="select select-flat select-xl"
                                options={countriesOptions}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <Field
                                name="team"
                                label="Team/Agency/Club"
                                placeholder="Team/Agency/Club"
                                component={Select}
                                className="select select-flat select-xl"
                                wrappedComponent={SelectSearch}
                                options={teamsOptions}
                            />
                        </Col>
                    </Row>
                    <Button variant="primary" disabled={!(props.isValid && props.dirty)} className="float-btn bottom-right lg" size="xl">Save</Button>
                </Form>
            )}
        </Formik>
    )
}

GeneralSettingsForm.defaultProps = {
    genderOptions: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
    ],
    countriesOptions: [
        { label: 'United State', value: 'usa' },
        { label: 'United Kingdom', value: 'uk' },
        { label: 'French', value: 'french' },
    ],
    teamsOptions: [
        { label: 'Barcelona', value: 'fcb' },
        { label: 'Real Madrid', value: 'rm' },
        { label: 'Bayren Munich', value: 'bm' },
    ]
}

export default GeneralSettingsForm
